/**
 * The visible half of §7.4's "skip with a logged warning". The session runner
 * still decides whether to skip the item entirely; the renderer's contribution
 * is never to crash and never to pretend.
 */
export function UnsupportedItem({
  itemId,
  type,
  reason,
}: {
  itemId: string
  type: string
  reason: 'unknown-type' | 'invalid-content' | 'not-yet-implemented'
}) {
  const explanation: Record<typeof reason, string> = {
    'unknown-type': 'Tento typ úlohy zatím neumíme zobrazit.',
    'invalid-content': 'Obsah úlohy neodpovídá očekávanému tvaru.',
    'not-yet-implemented': 'Tento typ úlohy je naplánovaný, ale ještě není hotový.',
  }

  return (
    <div className="sl-item sl-item--unsupported" data-item-id={itemId} data-reason={reason}>
      <p className="sl-unsupported__message">{explanation[reason]}</p>
      <p className="sl-unsupported__detail">
        <code>{type}</code> · <code>{itemId}</code>
      </p>
    </div>
  )
}
